import React from 'react';
import UpiidDetailsProvider from '../components/upiid-details/upiid-details-provider';
import CreateSolicitationContent from './create-solicitation-content';
import Breadcrumbs from '@/widgets/breadcrumbs';
import { breadcrumbsPath } from '../utils/solicitation-helpers';

const CreateSolicitation = () => {
  return (
    <>
      <Breadcrumbs current="New Solicitation" path={breadcrumbsPath} />
      <UpiidDetailsProvider>
        <CreateSolicitationContent />
      </UpiidDetailsProvider>
    </>
  );
};

export default CreateSolicitation;
